import React, { useEffect, useState } from 'react';
import FirebaseContext from './FirebaseContext';

export interface FirebaseProviderProps {
  disableInitialization?: boolean;
  children: React.ReactNode;
}

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const FirebaseProvider: React.FC<React.PropsWithChildren<FirebaseProviderProps>> = (props) => {
  const { disableInitialization = false, ...rest } = props;
  const [firebaseApp, setFirebaseApp] = useState(null);

  useEffect(() => {
    if (disableInitialization) return;
    if (firebaseApp) return;
    if (!Object.values(firebaseConfig).every(Boolean)) return;

    Promise.all([import('firebase/app'), import('firebase/analytics')])
      .then(([{ initializeApp, getApps, getApp }, { getAnalytics }]) => {
        const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
        getAnalytics(app);
        setFirebaseApp(app);
      })
      .catch((error) => console.error(error));
  }, [firebaseApp, disableInitialization]);

  return <FirebaseContext.Provider {...rest} value={firebaseApp} />;
};

export default FirebaseProvider;
